export const ODO_READING_FLOW_STEP_ONE: any = {
  flow_slug: 'odoReadingFlow',
  flow_version: 1,
  uuid: 'odo_reading_flow_step_one',
  heading: 'Add your car’s odometer',
  layout: '',
  settings: {
    align: 'center',
    submit_label: 'Save details'
  },
  interstitial: {
    type: 'default',
    settings: {
      icon: '/assets/svgs/common/loading-blue.svg',
      time: 4000
    },
    heading: 'Saving your odometer reading',
    content: [
      { text: 'Saving details' },
      { text: 'Updating Certificate of Insurance' },
      { text: 'Emailing new policy documents' }
    ]
  },
  sections: [
    {
      uuid: 'odo_reading_section',
      heading: 'Enter your odometer reading',
      subtext: '<p>If you need to make a claim and your odometer reading at the time of the claim is less than your start odometer reading or greater than your end odometer reading, a $1,000 additional excess will apply.</p>',
      layout: '',
      settings: {
        card: true,
        hero: 'management-addodometer'
      },
      elements: [
        {
          uuid: 'reading_question',
          subtext: '',
          layout: '',
          settings: {},
          prompt: 'Start odometer reading',
          key: 'reading',
          type: 'number',
          required: true,
          validations: [
            {
              predicate: {
                operands: ['<reading>', 0],
                operator: 'gt'
              },
              message: 'Please enter a valid odometer reading',
              layout: ''
            }
          ]
        },
      ]
    }
  ],
  data: {
    _flow_metadata: {
      current_page_uuid: 'odo_reading_flow_step_one'
    }
  },
  human: {},
  progress: 1,
  total_pages: 2,
  actions: {
    next: {}
  },
  analytics: {
    flow_slug: 'odoReadingFlow',
    flow_version: 1,
    page_uuid: 'odo_reading_flow_step_one'
  }
};

export const ODO_READING_FLOW_STEP_TWO: any = {
  flow_slug: 'odoReadingFlow',
  flow_version: 1,
  uuid: 'odo_reading_flow_step_two',
  heading: 'Your odometer reading has been added',
  layout: '',
  info: {
    settings: {},
    content:
      '<p>If you are coming close to your end odometer reading you can always top up your kilometres, online 24/7.</p>'
  },
  settings: {
    align: 'center',
    submit_label: 'View my policy'
  },
  sections: [
    {
      uuid: 'odo_success_section',
      subtext: '<p>Based on the number of kilometres you purchased, here are the start and end odometer readings for your policy:</p>',
      layout: '',
      settings: {
        card: true
      },
      info: {
        type: 'html',
        content: '<div class=\"review-timeline\"><ul><li class=\"active\"><open-svg-icon class=\"icon\"><span class=\"icon\"><svg viewbox=\"0 0 108 108\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"animate fill\"><path d=\"M54.8342 56.1143C52.0821 55.5835 49.624 57.6992 49.624 60.4075C49.624 62.8251 51.5837 64.7847 54.0013 64.7847C56.4188 64.7847 58.3639 62.8251 58.3639 60.4075C58.3639 59.3367 57.9788 58.3688 57.3405 57.6081L69.8494 36.3428L67.3346 34.8638L54.8342 56.1143Z\" fill=\"#8D94A5\"></path><path d=\"M54.0004 18.0942C33.8867 18.0942 17.5381 34.4575 17.5381 54.5711C17.5381 65.9385 22.2853 76.2725 33.1252 84.5171L40.1414 74.9982H67.8596L74.8757 84.5171C85.6825 76.2976 90.4627 65.9802 90.4627 54.5711C90.4627 34.4575 74.114 18.0942 54.0004 18.0942ZM75.4484 80.3764L69.3343 72.08H38.6665L32.5524 80.3764C24.8367 73.973 20.4562 64.6493 20.4562 54.5711C20.4562 36.067 35.4962 21.0124 54.0004 21.0124C72.5045 21.0124 87.5445 36.067 87.5445 54.5711C87.5445 64.6493 83.1641 73.973 75.4484 80.3764Z\" fill=\"#8D94A5\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M40.2939 80.0259H67.7048V91.5635H40.2939V80.0259ZM43.2121 82.944V88.6453H64.7867V82.944H43.2121Z\" fill=\"#8D94A5\"></path></g></svg></span></open-svg-icon><div class=\"milestone-content\"><div class=\"milestone-content-subtext\">Start odometer reading</div><div class=\"milestone-content-title\">{{start_odo}}<span class=\"km-label\">KM</span></div></div></li><li><open-svg-icon class=\"icon\"><span class=\"icon\"><svg viewbox=\"0 0 108 108\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"animate fill\"><path d=\"M28.7 42.4C28.9 42.7 29.1 43 29.3 43.2L30.3 44.5L31.3 43.3C31.5 43.1 31.7 42.8 31.9 42.5C33.3 40.8 35.2 38.5 36.8 36C38.6 33.2 40.3 30 40.3 27.2C40.3 22.1 36.5 17 30.3 17C27.2 17 24.8 18.3 23.3 20.3C21.7 22.2 21 24.7 21 27.2C21 30 22.5 33.2 24.2 35.9C25.7 38.3 27.4 40.6 28.7 42.4ZM25.2 21.8C26.4 20.4 28 19.5 30.3 19.5C34.9 19.5 37.8 23.2 37.8 27.2C37.8 29.3 36.5 31.9 34.7 34.7C33.3 36.8 31.7 38.8 30.3 40.5C29.1 38.8 27.6 36.8 26.3 34.7C24.6 31.9 23.5 29.3 23.5 27.3C23.5 25.2 24.1 23.3 25.2 21.8Z\" fill=\"#8D94A5\"></path><path d=\"M72.8 48.7C72.8 48.6 72.8 48.5 72.8 48.3C72.8 47.8 72.7 47.3 72.6 46.8C72.3 45.9 71.7 45.1 70.8 44.4C70.4 44.1 69.9 43.8 69.4 43.6C68.1 43 66.5 42.6 64.7 42.5C64.3 42.5 64 42.5 63.6 42.5H36.1V45H63.6C66.4 45 68.3 45.6 69.3 46.4C69.8 46.8 70.1 47.2 70.2 47.6C70.3 47.8 70.3 47.9 70.3 48.1C69.7 48 69.1 48 68.5 48C62.7 48 57.6 51.4 55.2 56.2H46.1C44.5 56.2 42.8 56.3 41.3 56.4C36.6 56.9 32.2 58.1 28.8 60.2C27.6 60.9 26.6 61.8 25.6 62.7C22.8 65.5 21.1 69.3 21.1 74.1C21.1 80.5 23.7 85 28.2 87.8C32.6 90.6 38.9 91.7 46.1 91.7H63.5V89.2H46.2C42.9 89.2 40 89 37.4 88.5C34.4 87.9 31.8 87 29.7 85.7C28.8 85.1 27.9 84.4 27.2 83.7C25 81.4 23.8 78.3 23.8 74.1C23.8 72.8 23.9 71.6 24.2 70.5C24.2 70.4 24.3 70.2 24.3 70.1C24.4 69.7 24.6 69.2 24.7 68.8C24.8 68.6 24.9 68.4 24.9 68.2C25.3 67.3 25.8 66.4 26.4 65.6C26.6 65.4 26.7 65.2 26.9 65C27.1 64.8 27.3 64.6 27.5 64.4C28.3 63.6 29.2 62.9 30.2 62.3C33.7 60.1 38.5 58.9 43.9 58.7C44.7 58.7 45.4 58.6 46.2 58.6H54.3C53.9 59.9 53.7 61.3 53.7 62.7C53.7 69.3 56.6 73.5 60.9 79.8C62.9 82.7 65.1 86 67.5 90.2L68.6 92L69.7 90.2C72.1 86 74.4 82.7 76.3 79.8C80.6 73.5 83.5 69.3 83.5 62.7C83.4 56.2 78.9 50.5 72.8 48.7ZM74.2 78.6C72.5 81.1 70.6 83.9 68.5 87.3C66.4 83.9 64.5 81.1 62.8 78.6C58.7 72.7 56.1 68.8 56.1 62.9C56.1 56.1 61.7 50.5 68.5 50.5C75.3 50.5 80.9 56.1 80.9 62.9C80.9 68.8 78.2 72.7 74.2 78.6Z\" fill=\"#8D94A5\"></path><path d=\"M68.5 56.6C65 56.6 62.2 59.4 62.2 62.9C62.2 66.4 65 69.2 68.5 69.2C72 69.2 74.8 66.4 74.8 62.9C74.8 59.4 72 56.6 68.5 56.6ZM72.4 62.9C72.4 65 70.7 66.8 68.5 66.8C66.4 66.8 64.6 65.1 64.6 62.9C64.6 60.8 66.3 59 68.5 59C70.7 59 72.4 60.8 72.4 62.9Z\" fill=\"#8D94A5\"></path></g></svg></span></open-svg-icon><div class=\"milestone-content\"><div class=\"milestone-content-subtext\">Your PAYD kilometres</div><div class=\"milestone-content-title\">{{payd_kms}}<span class=\"km-label\">KM</span></div></div></li><li><open-svg-icon class=\"icon\"><span class=\"icon\"><svg viewbox=\"0 0 108 108\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"animate fill\"><path d=\"M54.8342 56.1143C52.0821 55.5835 49.624 57.6992 49.624 60.4075C49.624 62.8251 51.5837 64.7847 54.0013 64.7847C56.4188 64.7847 58.3639 62.8251 58.3639 60.4075C58.3639 59.3367 57.9788 58.3688 57.3405 57.6081L69.8494 36.3428L67.3346 34.8638L54.8342 56.1143Z\" fill=\"#8D94A5\"></path><path d=\"M54.0004 18.0942C33.8867 18.0942 17.5381 34.4575 17.5381 54.5711C17.5381 65.9385 22.2853 76.2725 33.1252 84.5171L40.1414 74.9982H67.8596L74.8757 84.5171C85.6825 76.2976 90.4627 65.9802 90.4627 54.5711C90.4627 34.4575 74.114 18.0942 54.0004 18.0942ZM75.4484 80.3764L69.3343 72.08H38.6665L32.5524 80.3764C24.8367 73.973 20.4562 64.6493 20.4562 54.5711C20.4562 36.067 35.4962 21.0124 54.0004 21.0124C72.5045 21.0124 87.5445 36.067 87.5445 54.5711C87.5445 64.6493 83.1641 73.973 75.4484 80.3764Z\" fill=\"#8D94A5\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M40.2939 80.0259H67.7048V91.5635H40.2939V80.0259ZM43.2121 82.944V88.6453H64.7867V82.944H43.2121Z\" fill=\"#8D94A5\"></path></g></svg></span></open-svg-icon><div class=\"milestone-content\"><div class=\"milestone-content-subtext\">End odometer reading</div><div class=\"milestone-content-title\">{{end_odo}}<span class=\"km-label\">KM</span></div></li></div></li></ul></div>'
      }
    }
  ],
  data: {
    _flow_metadata: {
      current_page_uuid: 'odo_reading_flow_step_two'
    }
  },
  human: {},
  progress: 2,
  total_pages: 2,
  actions: {},
  analytics: {
    flow_slug: 'odoReadingFlow',
    flow_version: 1,
    page_uuid: 'odo_reading_flow_step_two'
  }
};

export const ODO_READING_EXISTS_FLOW_STEP_ONE = {
  flow_slug: 'odoReadingExistsFlow',
  flow_version: 1,
  uuid: 'odo_exists_flow_step_one',
  heading: 'We already have your odometer reading',
  layout: '',
  settings: {
    align: 'center',
    submit_label: 'View your policy'
  },
  sections: [
    {
      uuid: 'odo_exists_top_up_section',
      layout: '',
      heading: 'Will you drive more than your purchased kilometres?',
      settings: {
        hero: 'management-addkms',
        card: true
      },
      subtext:
        "<p>We get it, sometimes you drive more than expected. Luckily it’s easy to top up your kilometres online. Once you have logged in, select manage policy and then change your policy to add the extra kilometres.</p>",
      elements: []
    },
    {
      uuid: 'odo_exists_incorrect_section',
      layout: '',
      heading: 'Was your start odometer reading incorrect?',
      settings: {
        hero: 'management-addodometer',
        card: true
      },
      subtext:
        'If you think the start odometer reading you gave us wasn’t correct, please contact our insurance experts <a href="/support">here</a>.'
    }
  ],
  data: {
    _flow_metadata: {
      current_page_uuid: 'odo_exists_flow_step_one'
    }
  },
  human: {},
  progress: 1,
  total_pages: 1,
  actions: {},
  analytics: {
    flow_slug: 'odoReadingExistsFlow',
    flow_version: 1,
    page_uuid: 'odo_exists_flow_step_one'
  }
};

export const ERROR_ON_SAVE_INFO_BOX = {
  content: '<p><strong>We’re sorry, something went wrong</strong></p><p>We’re working on resolving this. Please try again.</p>',
  type: 'error',
  settings: {
    align: 'top'
  }
};